/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { StrictMode } from 'react'
import pkg from '../../package.json'
import '../styles/index.scss'
import App from './components/App'
import logger from './lib/logger'
import './lib/polyfill'
import { createRoot } from 'react-dom/client'

// Print app info in the console.
// eslint-disable-next-line no-undef
const nodeEnv = process.env.NODE_ENV
logger.info(`${pkg.name} v${pkg.version} (${nodeEnv})`)

const root = createRoot(document.getElementById('root')!)

root.render(
  <StrictMode>
    <App />
  </StrictMode>
)
